import type { PropertyName } from "@frui.ts/helpers";
import { bound } from "@frui.ts/helpers";
import { BusyWatcher, ScreenBase, watchBusy } from "@frui.ts/screens";
import { action, computed, observable } from "mobx";
import type LocalizationService from "services/localizationService";
import type { EntityNames } from "../config";

export default abstract class DetailViewModel<TEntity> extends ScreenBase {
  protected abstract readonly modelName: EntityNames;
  protected abstract localizationService: LocalizationService;
  protected abstract loadDetail(): Promise<TEntity> | TEntity;
  abstract translate(code: string, size?: number): string;
  busyWatcher = new BusyWatcher();
  @observable item: TEntity;

  @computed
  get isEditable() {
    return false;
  }

  @computed
  get isBusy() {
    return this.busyWatcher.isBusy;
  }

  constructor(protected itemId: string | number) {
    super();
    this.navigationName = `${this.itemId}`;
  }

  @action
  protected setItem(item: TEntity) {
    this.item = item;
  }

  @watchBusy
  async onInitialize() {
    try {
      const item = await this.loadDetail();
      this.setItem(item);
    } catch (e) {
      this.requestClose();
    }
    super.onInitialize();
  }

  @bound
  cancel() {
    this.requestClose();
  }

  translateGeneral(code: string, size?: number) {
    return this.localizationService.translateGeneral(code, size);
  }

  translateAttribute(attribute: PropertyName<TEntity>, size?: number) {
    return this.localizationService.translateAttribute(this.modelName, attribute, size);
  }

  translateSubAttribute(model: string, attribute: string) {
    return this.localizationService.translateAttribute(model, attribute);
  }
}
